import { render } from "./ExpanderVideo.vue?vue&type=template&id=2653035c&scoped=true"
import script from "./ExpanderVideo.vue?vue&type=script&lang=js"
export * from "./ExpanderVideo.vue?vue&type=script&lang=js"

import "./ExpanderVideo.vue?vue&type=style&index=0&id=2653035c&scoped=true&lang=scss"

import exportComponent from "/Users/ondrej/dev/www/_showheroes/2023/norway/helthjem-w49/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2653035c"]])

export default __exports__